import React from 'react';
import '../App.css';
import './HeroSection.css';

function VideosEnd() {
    return (
        <div className='hero-container'>
            <p>Prototype 1</p>
            <iframe width="820" height="715"
                src="https://www.youtube.com/embed/eo0-B5IbfW4">
            </iframe>
            <p>Prototype 2</p>
            <iframe width="820" height="715"
                src="https://www.youtube.com/embed/ZMY2QHYJ4eE">
            </iframe> 
        </div>
    );
}

export default VideosEnd;